<template>
  <div>
      <van-dialog v-model="praShow" mode="center" confirmButtonText="关闭"  :showCancelButton="false" :beforeClose="beforeCloseFn">
          <div class="img-box">
            <img :src="pickObj[qrcodeType]" />
          </div>
          <p style="font-size:12px;color:#010101;padding:0 30px">
            * 长按图片添加！
          </p>
      </van-dialog>
      <div class="box">
        <van-empty description="暂无二维码，请联系商务~" />
        <!-- <van-button plain type="info" size="small" url="https://work.weixin.qq.com/kfid/kfc94711f3cddb1d3ed">联系商务</van-button> -->
        <van-button plain type="info" size="small" @click="Business(qrcodeType)">联系商务</van-button>
      </div>
  </div>
</template>
<!-- <script type="text/javascript" src="https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js"></script> -->

<script type="text/javascript" src="https://gitee.com/dcloud/uni-app/raw/dev/dist/uni.webview.1.5.3.js"></script>
<script>
      console.log(window);

import * as wx from "weixin-js-sdk"
import { Empty } from 'vant';
import Vue from 'vue';
Vue.use( Empty );
export default {
    props:{
        qrcodeType:{
            type:String,
            default:"officialAccounts"
        }
    },

  data() {
    return {
    praShow:false,//小程序
      pickObj:{
        officialAccounts:'https://oss.shop.tczhilian.com/static/images/customer-service.jpg',
        miniProgram:'https://oss.shop.tczhilian.com/static/images/customer-service.jpg',
        websiteList:'https://oss.shop.tczhilian.com/static/images/customer-service.jpg',
      }
    };
  },
  methods: {
    Business(type) {
       let d = {
        corpId: 'ww3e28a6ccaa0974b3',//企业微信ID
        kfurl: 'https://work.weixin.qq.com/kfid/kfc94711f3cddb1d3ed',//企业微信客户接入链接
      }
      console.log(d);
      console.log(window); 
      window.parent.postMessage({data:d}, '*');
      // wx.miniProgram.postMessage({data:d})
      // uni.postMessage({
      //     data:{
      //       d
      //     }
      //   })
      // let p = Object.keys(d).reduce((p, k, i) => p + `${i ? '&' : '?'}${k}=${d[k]}`, '');
      // const {originPath,token,schemeId,modelId,imageId,productId,orderId} = this.$route.query
      // let url = 'https://3d.yinqu.tczhilian.com/cup-demo/editstyle'
      // let param = 1
      // if (schemeId) {
      //   param = 2
      //   wx.miniProgram.redirectTo({ url: `/pages_category_page1/linkOthers/link3D${p}&param=${param}&url=${url}&token=${token}&originPath=${originPath}&schemeId=${schemeId}&modelId=${modelId}` });//触发小程序刷新页面获取appId
        
      // }else if(imageId){
      //   param = 3
      //   wx.miniProgram.redirectTo({ url: `/pages_category_page1/linkOthers/link3D${p}&param=${param}&url=${url}&token=${token}&originPath=${originPath}&imageId=${imageId}&modelId=${modelId}` });//触发小程序刷新页面获取appId

      // }else if(productId){
      //   param = 4
      //   wx.miniProgram.redirectTo({ url: `/pages_category_page1/linkOthers/link3D${p}&param=${param}&url=${url}&token=${token}&originPath=${originPath}&productId=${productId}&orderId=${orderId}&schemeId=${schemeId}&modelId=${modelId}` });//触发小程序刷新页面获取appId
      // }else{
      //   param = 1
      //   wx.miniProgram.redirectTo({ url: `/pages_category_page1/linkOthers/link3D${p}&param=${param}&url=${url}&token=${token}&originPath=${originPath}` });//触发小程序刷新页面获取appId
      // }
      this.praShow = true;
      console.log(type);
      
    },
    beforeCloseFn(action, done){
       if (action === 'confirm') {
        done()
      } else {
        // 如果点击了取消按钮，则阻止对话框关闭
        done()
      }
    }

  },
};
</script>

<style lang="scss" scoped>
.box{
    display: flex;
    flex-direction: column;
}
.img-box{
    width: 250px;
    height: 250px;
    padding: 20px 0 0;
    margin: 0 auto;
    img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
::v-deep{
    .van-empty{
        padding: 0;
    }
    .van-empty__image {
        width: 70px;
        height: 70px;
    }
    .van-empty__description {
         margin-top: 0; 
         padding: 0; 
         line-height: 20px; 
    }
    .van-button--small {
        border-radius: 16px
      }
    
}
</style>
